import { render, staticRenderFns } from "./UserPackageList.vue?vue&type=template&id=3cd493b2"
import script from "./UserPackageList.vue?vue&type=script&lang=js"
export * from "./UserPackageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports